import React from "react";
import { STORAGE_ASSETS } from "../../Const/BaseUrlConst";

type EmailWhiteProps = React.HTMLAttributes<HTMLDivElement> & {};

export const EmailWhite: React.FC<EmailWhiteProps> = ({ ...props }) => {
  return (
    <div {...props}>
      <img src={STORAGE_ASSETS+"/images/svg/email-white.svg"} alt="" />
    </div>
  );
};